export const PERMS = {
    READ: 'report_customer_speditions.read',
    UPDATE: 'report_customer_speditions.update',
    DELETE: 'report_customer_speditions.delete',
    CREATE: 'report_customer_speditions.create',
    EXPORT: 'report_customer_speditions.export',
}
